import { render, staticRenderFns } from "./ChatActions.vue?vue&type=template&id=cb3e1ffe&scoped=true"
import script from "./ChatActions.vue?vue&type=script&lang=js"
export * from "./ChatActions.vue?vue&type=script&lang=js"
import style0 from "./ChatActions.vue?vue&type=style&index=0&id=cb3e1ffe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb3e1ffe",
  null
  
)

export default component.exports